import { rankingData } from '@/mocks/home';

export default function SectionRanking() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 flex items-center justify-center bg-accent-100 rounded-lg">
              <i className="ri-trophy-line text-accent-600 text-lg"></i>
            </div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              今日瓜王排行榜
            </h2>
          </div>
          <span className="text-xs text-foreground-500 bg-background-100 px-3 py-1.5 rounded-full">
            实时更新 · 每小时刷新
          </span>
        </div>

        <div className="space-y-3">
          {rankingData.map((item) => (
            <div
              key={item.id}
              className="bg-background-100 rounded-xl p-4 md:p-5 hover:bg-background-200/70 transition-colors cursor-pointer flex items-center gap-4"
            >
              <div className={`w-10 h-10 md:w-12 md:h-12 rounded-xl flex items-center justify-center flex-shrink-0 ${
                item.rank === 1
                  ? 'bg-accent-500 text-background-50'
                  : item.rank === 2
                    ? 'bg-secondary-500 text-background-50'
                    : item.rank === 3
                      ? 'bg-primary-400 text-background-50'
                      : 'bg-background-200 text-foreground-600'
              }`}>
                <span className="font-heading text-lg md:text-xl font-bold">
                  {item.rank <= 3 ? (
                    <i className={`text-lg ${
                      item.rank === 1 ? 'ri-medal-fill' : item.rank === 2 ? 'ri-medal-fill' : 'ri-medal-fill'
                    }`}></i>
                  ) : (
                    `0${item.rank}`
                  )}
                </span>
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-sm md:text-base font-semibold text-foreground-900 truncate">
                    {item.title}
                  </span>
                  {item.hot && (
                    <span className="flex items-center gap-0.5 text-[10px] text-primary-600 bg-primary-50 px-1.5 py-0.5 rounded-full flex-shrink-0">
                      <i className="ri-fire-line"></i>热
                    </span>
                  )}
                </div>
                <div className="flex items-center gap-2 text-xs text-foreground-500">
                  <span className="bg-secondary-100 text-secondary-700 px-1.5 py-0.5 rounded">
                    {item.category}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className={`text-[10px] ${
                      item.trend === 'up' ? 'ri-arrow-up-line text-primary-500' : 'ri-arrow-down-line text-secondary-500'
                    }`}></i>
                    {item.change}
                  </span>
                </div>
              </div>

              <div className="text-right flex-shrink-0">
                <div className="text-sm md:text-base font-heading font-bold text-primary-600">
                  {item.votes}
                </div>
                <button className="text-xs text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap mt-1">
                  投票 <i className="ri-arrow-right-s-line"></i>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}